// create bar graph that takes values from accesslog and returns them in a pretty form
// input
import * as React from "react";
import * as d3 from "d3";
import { useEffect, useState } from "react";

type BarGraphProps = {
  [x: string]: any;
  data: Array<{
    label: Date;
    val: number;
  }>;
};

function BarGraph(props: BarGraphProps) {
  // to enable multiple images on same page
  function generateUUID() {
    return "BarG_xxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  const [container, setContainer] = useState(generateUUID());
  //console.log("insideBG:", props.data)
  useEffect(() => {
    if (props.data.length > 0) {
      drawChart();
      //console.log('is this being called???')
    } else {
      d3.select("#" + container)
        .selectChildren()
        .remove();
      //console.log('is this being called')
      //console.log(props.data)
    }
  }, [props]);

  const drawChart = () => {
    // Declare the chart dimensions and margins.
    const width = props.width;
    const height = 500;
    const marginTop = 20;
    const marginRight = 30;
    const marginBottom = 30;
    const marginLeft = 40;

    // Declare the x (horizontal position) scale.
    // const xScale = d3.scaleUtc(
    //         d3.extent(props.data, (d) => d.label),
    //         [marginLeft, width - marginRight]
    //     );

    const xScale = d3
      .scaleBand()
      .range([marginLeft, width - marginRight])
      .domain(
        props.data.map(
          (d) =>
            (d.label.getMonth() + 1).toString() +
            " " +
            "/" +
            " " +
            d.label.getUTCFullYear().toString(),
        ),
      )
      .padding(0.1);
    //console.log("max:", d3.max(props.data, (d) => d.val))
    // Declare the y (vertical position) scale.
    const yScale = d3
      .scaleLinear()
      .domain([0, d3.max(props.data, (d) => d.val)])
      .range([height - marginBottom, marginTop]);

    d3.select("#" + container)
      .selectChildren()
      .remove();
    // Create the SVG container.

    const svg = d3
      .select("#" + container)
      .append("svg")
      .attr("width", width)
      .attr("height", height + 100)
      .attr("viewBox", [0, 0, width, height + 80]);

    // Add a rect for each bar.
    svg
      .append("g")
      .attr("fill", "#007a87")
      .selectAll()
      .data(props.data)
      .join("rect")
      .attr("x", (d) =>
        xScale(
          (d.label.getMonth() + 1).toString() +
            " " +
            "/" +
            " " +
            d.label.getUTCFullYear().toString(),
        ),
      )
      .attr("y", (d) => yScale(d.val))
      .attr("height", (d) => yScale(0) - yScale(d.val))
      .attr("width", xScale.bandwidth());

    // Add the x-axis and label.
    svg
      .append("g")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3
          .axisBottom(xScale)
          .ticks(props.data.length, d3.utcFormat("%B %Y"))
          .tickSizeInner(10)
          .tickSizeOuter(5)
          .tickFormat(null),
        //.tickSizeOuter(0),
      )
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-1.35em")
      .attr("dy", "-0.6em")
      .attr("transform", "rotate(-80)");
    // Add the y-axis and label, and remove the domain line.
    svg
      .append("g")
      .attr("transform", `translate(${marginLeft},0)`)
      .call(
        d3
          .axisLeft(yScale)
          //.tickFormat((y) => (y * 100).toFixed())
          .tickFormat(null),
      )
      .call((g) => g.select(".domain").remove())
      .call((g) =>
        g
          .append("text")
          .attr("x", -marginLeft)
          .attr("y", 10)
          .attr("fill", "currentColor")
          .attr("text-anchor", "start")
          .text("↑ Times AOS Accessed"),
      );
  };
  return (
    //<div>
    <div className={"BarGraph"} id={container} />
    //</div>
  );
}
export default BarGraph;
